import React from "react";
import { toast } from "react-toastify";
import Dialog from "../../../components/ui/Dialog";

/**
 * A generated password that could not be emailed: shown once, for HR to pass
 * on. It lives only in the page's state and is gone when this closes.
 * `busy` keeps Escape and the backdrop from closing it by accident: Done only.
 */
const TemporaryPasswordDialog = ({ email, password, onClose }) => {
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(password);
      toast.success("Temporary password copied.");
    } catch {
      toast.error("Could not copy. Select the password and copy it by hand.");
    }
  };

  return (
    <Dialog
      title="Temporary password"
      subtitle={email}
      onClose={onClose}
      busy
      footer={
        <button
          type="button"
          className="btn btn-primary profile-btn"
          onClick={onClose}
        >
          Done
        </button>
      }
    >
      <p className="fs-085">
        Pass this on to the user now: it won't be shown again. They must change
        it when they first sign in.
      </p>
      <div className="d-flex align-items-center gap-2">
        <code className="form-control user-select-all text-break">
          {password}
        </code>
        <button
          type="button"
          className="btn btn-outline-secondary text-nowrap"
          onClick={copy}
        >
          <i className="bi bi-clipboard me-1"></i>Copy
        </button>
      </div>
    </Dialog>
  );
};

export default TemporaryPasswordDialog;
